import Table from './Table'
import './Table.less'

export default Table
